export const TELTONIKA_FILES_COMPANY = 2;
export const TELTONIKA_COMPANY = 101;
export const CARRIER_COMPANY = 9347;
